import { render } from "./Or_pdfviewer.vue?vue&type=template&id=63c1fd4a&ts=true"
import script from "./Or_pdfviewer.vue?vue&type=script&lang=ts"
export * from "./Or_pdfviewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__